import template from './ActionCardView.html';
import './ActionCard.scss';
class ActionCardController {
    constructor() { }
}
export const ActionCardComponent = {
    template,
    controller: ActionCardController,
    controllerAs: '$ctrl',
    bindings: {
        label: '@',
        text: '@',
        icon: '@',
    },
};
